"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_redux_1 = require("react-redux");
var redux_1 = __importDefault(require("./redux"));
var Root_1 = __importDefault(require("./components/Root"));
var styled_components_1 = require("styled-components");
var theme_1 = require("../styles/theme");
var App = function (props) {
    var state = Object.assign({}, props.state);
    var store = (0, redux_1.default)(state);
    return (react_1.default.createElement(styled_components_1.ThemeProvider, { theme: theme_1.theme },
        react_1.default.createElement(react_redux_1.Provider, { store: store },
            react_1.default.createElement(Root_1.default, null))));
};
exports.default = App;
